module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m_context plr"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "id": "addForm",
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.otaName'),
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.version'),
      "prop": "version"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.version),
      callback: function($$v) {
        _vm.$set(_vm.form, "version", $$v)
      },
      expression: "form.version"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#8391a5",
      "font-size": "12px",
      "line-height": "2",
      "margin-top": "4px"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.verTips1')))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.risk_desc'),
      "prop": "memo"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.memo),
      callback: function($$v) {
        _vm.$set(_vm.form, "memo", $$v)
      },
      expression: "form.memo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.selectWenjian'),
      "prop": "filePath"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "drag": "",
      "action": _vm.action,
      "file-list": _vm.fileList,
      "on-success": _vm.handleAvatarScucess,
      "on-error": _vm.uploadError,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.jwjtdcc'))), _c('em', [_vm._v(_vm._s(_vm.$t('lin_global.djsc')))])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('lin_global.qsczipwj')))])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_udfiletype'),
      "prop": ""
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.udFileType),
      callback: function($$v) {
        _vm.udFileType = $$v
      },
      expression: "udFileType"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ttPkg')))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.udFileType),
      callback: function($$v) {
        _vm.udFileType = $$v
      },
      expression: "udFileType"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_dfPkg')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.udFileType == 1),
      expression: "udFileType == 1"
    }],
    attrs: {
      "label": _vm.$t('app_preversion'),
      "prop": "preVersion"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.preVersion),
      callback: function($$v) {
        _vm.$set(_vm.form, "preVersion", $$v)
      },
      expression: "form.preVersion"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#8391a5",
      "font-size": "12px",
      "line-height": "2",
      "margin-top": "4px"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.verTips')))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (0),
      expression: "0"
    }],
    attrs: {
      "label": _vm.$t('lin_global.qmzst')
    }
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.check
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.sfsyzdqm')))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.zdqds'),
      "prop": "mechanismId"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true,
      "classs": 'w_33'
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "id": "onCancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isSubmit
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.add')))])], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f13c8d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/romUpload.vue
// module id = 1036
// module chunks = 0